
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"158","height":"25","viewBox":"0 0 158 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".935","width":"25","height":"25","rx":"2","fill":"#DC2626"}}),_c('path',{attrs:{"d":"M31.935 2a2 2 0 012-2h1a2 2 0 012 2v21a2 2 0 01-2 2h-1a2 2 0 01-2-2V2z","fill":"#DC2626"}}),_c('path',{attrs:{"d":"M34.935 8.712V.5c0-.5 0-.5-.41-.5h-2.788C30.98 0 30.28.493 29.9 1.295l-4.683 9.91a3.097 3.097 0 000 2.59l4.683 9.91c.38.802 1.079 1.295 1.836 1.295h2.788c.41 0 .41 0 .41-.5v-9.154c0-.346-.005-6.634 0-6.634z","fill":"#DC2626"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.935 0h6.385v11.252h.067L60.447 0h6.69l-8.276 12.467L67.678 25h-7.466l-6.825-10.811h-.067V25h-6.385V0zM72.679 25h6.386V0h-6.386v25zM94.87 7.488c-.13-.813-.325-2.344-2.212-2.344-1.075 0-2.117.75-2.117 1.89 0 1.431.652 1.724 4.982 3.676 4.49 2.02 5.631 4.103 5.631 6.901 0 3.515-2.02 7.389-8.399 7.389-6.966 0-8.69-4.555-8.69-7.649v-.78h6.118c0 2.798 1.726 3.288 2.508 3.288 1.464 0 2.343-1.205 2.343-2.31 0-1.597-1.009-1.988-4.72-3.551-1.693-.682-5.892-2.377-5.892-6.899 0-4.525 4.395-7.099 8.43-7.099 2.376 0 4.948.882 6.511 2.735 1.432 1.758 1.529 3.387 1.595 4.753h-6.087zM112.64 0l3.344 16.249h.067L119.735 0h4.898l3.614 16.317h.068L131.727 0h6.453l-6.622 25h-5.609L122.2 8.816h-.067L118.382 25h-5.776l-6.453-25h6.487zM143.18 0h13.885v5.609h-7.769v3.883h7.533v5.61h-7.533v4.29h7.769V25H143.18V0z","fill":"#DC2626"}})])
          )
        }
      }
    